import { Component, ViewChild } from '@angular/core';
import { SecurityAgreementViewService } from './security.agreement.view.service';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { AppService } from '../../app.service';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Globals } from '../../globals';
import { ActivatedRoute } from '@angular/router';
import translateJson from "../../../translate.json";
import { PersonFormService } from '../../PersonComponent/PersonFormComponent/person.form.service';
import { PersonViewService } from '../../PersonComponent/PersonViewComponent/person.view.service';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { HttpResponse } from '@angular/common/http';
import { ErrorModalComponent } from '../../shared/views/ErrorModalComponent/error.modal.component';
import { AuthenticationService } from '../../auth';

@Component({
    selector: 'security-comp',
    providers: [SecurityAgreementViewService, ConfirmService, NgxSmartModalService, PersonViewService, PersonFormService, AppService, AuthenticationService], 
    templateUrl: './security.agreement.view.component.html',  
    styleUrls: ['../security.agreement.css']  
})

export class SecurityAgreementViewComponent {   

    @ViewChild('errorModalComponent') errorModalComponent: ErrorModalComponent; 

    // Get translation/text from customerJson
    private i18 = translateJson.i18;
  
    private activeComponent: boolean;
    private serialNumber: string;
    private fas: any;
    private ready: boolean = false;

    // Attachment variables
    selectedFiles: FileList;
    currentFileUpload: FileLikeObject;
    public uploader: FileUploader = new FileUploader({allowedFileType: ["pdf"]});
    showLoader: Boolean = false;
    showAttBody: Boolean = false;
    private attachmentContent: any;
    private showContentForAttachment: Boolean = false;
    private newAttachment: Boolean = false;    

    constructor(
        private service: SecurityAgreementViewService,          
        private confirmService: ConfirmService,
        private activatedRoute: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private personService: PersonFormService,
        private personViewService: PersonViewService,
        private location : Location,
        private ngxSmartModalService: NgxSmartModalService,
        private globals: Globals,
        private appService: AppService,
        private authService: AuthenticationService) {
            this.authService.isAuthenticated(); 
            this.activeComponent = appService.isComponentActive('securityAgreement');
            this.serialNumber = this.activatedRoute.snapshot.paramMap.get('id');
            this.setDefault();  
            this.ready = true;
        }

    /**
    * Default method that prepares the form
    */
    setDefault() {
        this.getSecurityAgreementById(this.serialNumber);
    }

    /**
    * Method used to talk with the service and forwards the result
    */
    getSecurityAgreementById(fasId) {
        this.service.getSecurityAgreementById(fasId)      
        .subscribe(
            data => this.setDataToFas(data),
            error =>  console.log(error),
        );   
    }

    /**
    * Set all values required in HTML to allow for presentation
    */
    setDataToFas(data) {
        this.fas = data;
        this.ready = true;
    }

    /**
    * Method used to talk with the service for PDF download
    * Forwards the result (a byte array) to the users browser and starts a download
    */
    exportSecurityAgreement(fasId) {
        this.service.exportSecurityAgreement(fasId)      
        .subscribe(
            data => this.startPdfDownload(data, this.fas.companyName),
            error =>  console.log(error),
        );
    }

    /**
    * Method to start downloading the byte array recieved from the server as a PDF to local storage
    */
    startPdfDownload(data, fileName) {
        if(window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(data, fileName + ".pdf");
        } else {
            const url = window.URL.createObjectURL(data);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = fileName + ".pdf";
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    /**
    * Simple helper to redirect the user to the edit-view
    */
    editSecurityAgreement() {
        this.appService.setRoute('securityAgreement/edit/' + this.fas.id);
    }

    /**
    * Simple helper to return to the place we came from
    */
    back() {
        this.appService.setRoute("/securityAgreement");
    }

    /**
    * Archives an existing security agreement
    */
    archiveSecurityAgreement(fasId) {
        this.confirmService.confirm('Vill du verkligen arkivera detta FAS-avtal?')
        .then(result => {
            if(result) {
                this.service.archiveSecurityAgreement(fasId)
                    .subscribe(
                        data => this.setDataToFas(data),
                        error => console.log(error)
                    )
            }
        });
    }

    /**
    * Restores an archived security agreement
    */
    restoreSecurityAgreement(fasId) {
        this.confirmService.confirm('Vill du verkligen återskapa detta FAS-avtal från arkivering?')
        .then(result => {
            if(result) {
                this.service.restoreArchivedSecurityAgreement(fasId)
                    .subscribe(
                        data => this.setDataToFas(data),
                        error => console.log(error)
                    )
            }
        });
    }

    showAttachment() {
        this.ngxSmartModalService.getModal('attachmentModal').open();
    }

    ngAfterViewInit() {
        this.ngxSmartModalService.getModal('attachmentModal').onDismiss.subscribe((modal: NgxSmartModalComponent) => {
            // modal is the dismissed modal, so do what you want with it
            this.resetModal();
        });
    }

    resetModal() {
        this.newAttachment = false;
        this.showAttBody = false;
        this.uploader.clearQueue();
    }

    showAttachmentBody() {
        this.showAttBody = true;
    }

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }

    showUploader() {
        this.newAttachment = true;
    }

    getFiles(): FileLikeObject[] {
        return this.uploader.queue.map((fileItem) => {
            return fileItem.file;
        });
    }

    upload() {
        let files = this.getFiles();

        for(let i=0; i < files.length; i++) {
            let formData = new FormData();
            formData.append('file', files[i].rawFile, files[i].name);
            this.personViewService.upload(formData).subscribe(event => {
                if(event.status != 200) {
                    return;
                }
                if(event instanceof HttpResponse) {
                    let securityAgreementAttachment = {
                        readableName: files[i].name,
                      }
                      this.service.saveAttachment(securityAgreementAttachment, "securityAgreement", this.serialNumber).subscribe(
                        data => this.uploadReady(),
                        error => console.log(error)
                    )
                }
            })
        }
    }

    renderAttachment(data) {
        var file = new Blob([(data)], {type: 'application/pdf'});
        var fileUrl = URL.createObjectURL(file);
        this.sanitizeUrl(fileUrl);
    }

    sanitizeUrl(url) {
        this.attachmentContent = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.showContentForAttachment = true;
    }

    showAttachedFile(id) {
        this.personViewService.showAttachedFile(id).subscribe(
            data => this.renderAttachment(data),
            error => console.log(error)
        );
    }

    uploadReady() {
        this.getSecurityAgreementById(this.serialNumber);
        this.uploader.clearQueue();
        this.newAttachment = false;
    }

     /**
     * Delete a attachment
     * @param attachmentId uuid of attachment
     * @param attachmentName name of attachment
     */
    deleteAttachment(attachmentId, attachmentName){
        this.confirmService.confirm('Vill du radera bilagan med namn: ' + attachmentName)
            .then(result => {
                if(result) {
                    this.service.deleteAttachment(attachmentId, this.serialNumber)
                        .subscribe(
                            data => this.getSecurityAgreementById(this.serialNumber),
                            error => this.showErrorModal(this.errorModalComponent.getErrorModalArray(), error)
                        )
                }
            });
    }

    /**
     * Show error modal
     * @param modalData modalData array
     * @param error error msg
     */
    showErrorModal(modalData, error) {
        modalData[0] = error.header;
        modalData[1] = error.title;
        modalData[2] = error.message;
        this.errorModalComponent.pop();
    }
}